import htmx from "htmx.org";
import "../sass/app.scss";
import { uaCheck } from "../modules/utils";
import "../../node_modules/css-modules-hf/dist/modules-reset.css"; // CSSモジュール
import "../../node_modules/css-modules-hf/dist/modules.css"; // CSSモジュール

uaCheck();

// ▼▼▼▼▼ DOMが安定した後に実行
const HTMX_ELM_COUNT = htmx.findAll(`[hx-trigger="load"]`).length;
let LOADED_COUNT = 0;
htmx.on("htmx:afterSettle", () => {
  LOADED_COUNT += 1;

  if (HTMX_ELM_COUNT === LOADED_COUNT) {
    // ここにDOMが安定した後に実行したい処理を記述する
    window.addEventListener('load', () => {
      if (window.location.hash) {
        const targetId = window.location.hash.substring(1);
        const target = document.getElementById(targetId);

        if (!target) return;

        const header = document.querySelector('header'); // 固定ヘッダー要素
        const headerHeight = header ? header.offsetHeight + 50 : 0; // ヘッダーの高さ取得
        const y = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

        window.scrollTo({
          top: y,
          behavior: "smooth"
        });
      }
    });
  }
});
// ▲▲▲▲▲
